export default __webpack_public_path__ + "static/media/youtube.6f9e32ba.png";